module.exports = __webpack_public_path__ + "media/images/policy-bg-5e2d201f3b7b22b952ecfdf588a40ad5.png";